var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTasksButtonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.727273 0H15.2727C15.6744 0 16 0.325611 16 0.727273V15.2727C16 15.6744 15.6744 16 15.2727 16H0.727273C0.325611 16 0 15.6744 0 15.2727V0.727273C0 0.325611 0.325611 0 0.727273 0ZM1.45443 14.5455H14.5453V1.45455H1.45443V14.5455Z",
    fill: "#3030AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36363 12.3636C4.76529 12.3636 5.0909 12.038 5.0909 11.6364V6.54545C5.0909 6.14379 4.76529 5.81818 4.36363 5.81818C3.96196 5.81818 3.63635 6.14379 3.63635 6.54545V11.6364C3.63635 12.038 3.96196 12.3636 4.36363 12.3636Z",
    fill: "#3030AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 12.3636C8.40176 12.3636 8.72737 12.038 8.72737 11.6364V4.36364C8.72737 3.96198 8.40176 3.63637 8.0001 3.63637C7.59844 3.63637 7.27283 3.96198 7.27283 4.36364V11.6364C7.27283 12.038 7.59844 12.3636 8.0001 12.3636Z",
    fill: "#3030AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6365 12.3636C12.0381 12.3636 12.3637 12.038 12.3637 11.6364V6.54545C12.3637 6.14379 12.0381 5.81818 11.6365 5.81818C11.2348 5.81818 10.9092 6.14379 10.9092 6.54545V11.6364C10.9092 12.038 11.2348 12.3636 11.6365 12.3636Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTasksButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tasksButtonIcon.46add4f00c454d2f0261ddcfed482081.svg";